export const SHOW_ACTIVATION_MODAL = 'SHOW_ACTIVATION_MODAL'
export const CLOSE_ACTIVATION_MODAL = 'CLOSE_ACTIVATION_MODAL'


export const showActivationModal = () => ({
  type: SHOW_ACTIVATION_MODAL
})

export const closeActivationModal = () => ({
  type: CLOSE_ACTIVATION_MODAL
})



// WEBPACK FOOTER //
// ./src/actions/activation.js